import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@components/header/header.component';
import { MenuComponent } from '@components/menu/menu.component';
import Hotjar from '@hotjar/browser';
import { FormDataService } from '@mds/ui';
import { LocalStorageService } from '@services/local-storage.service';
import { GenericApiService } from '@services/generic-api.service';
import { MenuService } from '@services/menu.service';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [
    {
      provide: FormDataService,
      useFactory: (svc: GenericApiService) => new FormDataService(svc),
      deps: [GenericApiService]
    }
  ],
  standalone: true,
  imports: [HeaderComponent, MenuComponent, RouterOutlet, CommonModule]
})
export class LayoutComponent implements AfterViewInit, OnInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  private menuService = inject(MenuService);
  menuConfig$ = this.menuService.menuConfig$;
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);

  ngOnInit(): void {
    const userInfo = this.localStorageService.getItem('user_info');

    // NOTE: we explicitly check if opt_out_of_ux_tracking is false to prevent null/undefined passing
    if (userInfo?.opt_out_of_ux_tracking === false) {
      this.initHotjar();
    }

    if (userInfo) {
      this.menuService.initAppsAndImports();
    }
  }

  private initHotjar(): void {
    const isOnLocal = window.location.origin.includes('localhost:');
    const isOnSandbox = window.location.origin.includes('.sbx.makersite.app');

    if (!environment?.isProduction || isOnLocal || isOnSandbox) return;

    const siteId = 2974236;
    const hotjarVersion = 6;

    Hotjar.init(siteId, hotjarVersion);
  }

  ngAfterViewInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.scrollContainer?.nativeElement?.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}
